import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Phone, ClipboardList, ArrowRight } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';

export default function Booking() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-cyan-50">
      <Seo title="Book an Appointment" path="/booking" description="Book your pet's grooming appointment online at Bubbles & Bark, Orlando FL. Full spa, mini spa, baths and cat grooming — pick a time in under two minutes." />
      <Header showContactInfo={true} showBookNowButton={false} />

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <Calendar className="w-8 h-8 text-pink-600" />
            <h1 className="text-4xl font-bold text-gray-800">Book an Appointment</h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose your service and pick a time that suits you. You'll get a confirmation
            as soon as your booking is complete.
          </p>
        </div>

        {/* New clients: intake form before the first visit */}
        <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-2xl p-6 mb-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center space-x-4">
            <div className="bg-purple-100 rounded-full p-3">
              <ClipboardList className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">First time visiting us?</h2>
              <p className="text-gray-600">
                Please complete our New Client Intake Form so we know all about your pet before their spa day.
              </p>
            </div>
          </div>
          <Link
            to="/intake-form"
            className="inline-flex items-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-full font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 whitespace-nowrap"
          >
            <span>Fill Intake Form</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="w-full h-[800px]">
            <iframe
              src="https://booking.moego.pet/ol/BubblesBark/book?utm_medium=embed"
              width="100%"
              height="100%"
              frameBorder="0"
              title="Online booking"
              scrolling="no"
            ></iframe>
          </div>
        </div>

        {/* Fallback: the booking widget is third-party, so always leave a way through */}
        <div className="text-center mt-8">
          <p className="text-gray-600 mb-3">Having trouble booking online?</p>
          <a
            href="tel:+14078688608"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-cyan-500 hover:from-pink-600 hover:to-cyan-600 text-white px-6 py-3 rounded-full font-bold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <Phone className="w-4 h-4" />
            <span>Call us on (407) 868-8608</span>
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
